import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InnerCommunicationDataPassService } from '../../services/inner-communication-data-pass.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-map-delete-inner-confirmation',
    templateUrl: './map-delete-inner-confirmation.component.html',
    styleUrls: ['./map-delete-inner-confirmation.component.scss'],
    standalone: false
})
export class MapDeleteInnerConfirmationComponent implements OnInit {
    @Input() mapName: string = '';
    
    // Confirmation Checkboxes
    confirmWorldMap = false;
    confirmWiki = false;
    confirmGames = false;
    confirmCharacters = false;

    constructor(
        public activeModal: NgbActiveModal,
        private innerCommunicationDataPassService: InnerCommunicationDataPassService,
        private router: Router
    ) { }

    ngOnInit(): void {
    }

    get canDelete(): boolean {
        return this.confirmWorldMap && this.confirmWiki && this.confirmGames && this.confirmCharacters;
    }

    confirmDelete() {
        this.activeModal.close('proceed');
    }

    cancel() {
        this.activeModal.close('close');
        this.innerCommunicationDataPassService.childModalCloseEvent(true);
    }
    
    subscribe() {
        this.activeModal.close('subscribe');
        this.router.navigate(['/subscription']);
    }
}
